import React from 'react'
import { Trans } from '@lingui/react'
import styled from 'styled-components'

import OnboardingModal from '../../onboarding/OnboardingModal'

import PrimaryButton from '../../../util/PrimaryButton'
import Checkbox from '../../../util/Checkbox'
import LinkButton from '../../../util/LinkButton'
import Tooltip from '../../../util/Tooltip'

import { TERMS_AND_CONDITIONS_URL, PRIVACY_POLICY_URL } from '../../../../util/constants'

const AdminOnboardingModalGetStarted = ({
    disclaimerChecked,
    handleCheckDisclaimer,
    isSubmitting,
    onGetStarted,
    ...props
}) => {
    const termsAndConditionsUrl = (
        <StyledLinkButton href={TERMS_AND_CONDITIONS_URL} target="_blank">
            <Trans id="terms & conditions" />
        </StyledLinkButton>
    )
    const privacyStatementUrl = (
        <StyledLinkButton href={PRIVACY_POLICY_URL} target="_blank">
            <Trans id="privacy policy" />
        </StyledLinkButton>
    )
    return (
        <OnboardingModal
            title={<Trans id="Ready to go!" />}
            subTitle={
                <Trans id="You have succesfully setup your account on Lexor." />
            }
            {...props}
        >
            <Container>
                <Checkbox
                    checked={disclaimerChecked}
                    onChange={(e) => handleCheckDisclaimer(e.target.checked)}
                >
                    <Trans 
                    id="I agree with the {termsAndConditionsUrl} and 
                        {privacyStatementUrl}"
                    values={{ termsAndConditionsUrl, privacyStatementUrl }}/>
                </Checkbox>
            </Container>
            <ButtonContainer>
                <Tooltip
                    show={!disclaimerChecked}
                    label={
                        <Trans id="Please accept our terms & conditions and privacy policy"/>
                    }
                >
                    <div>
                        <GetStartedButton
                            onClick={onGetStarted}
                            disabled={!disclaimerChecked || isSubmitting}
                            isLoading={isSubmitting}
                        >
                            <Trans id="Start using Lexor" />
                        </GetStartedButton>
                    </div>
                </Tooltip>
            </ButtonContainer>
        </OnboardingModal>
    )
}

const StyledLinkButton = styled(LinkButton)`
    :hover {
        text-decoration: underline;
    }
`

const Container = styled.div(
    ({ theme }) => `
    margin-top: ${theme.spacing}rem;
    margin-bottom: ${theme.spacing}rem;
`,
)

const ButtonContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`

const GetStartedButton = styled(PrimaryButton)(
    ({ theme }) => `
    min-width: 20rem;
    margin: ${theme.spacingSmall}rem;
    align: center;
`,
)

export default AdminOnboardingModalGetStarted
